<template>
  <div>
    <!-- <v-row id="product__rowpadding" v-if="communication_type === 1"> -->
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Incentive #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-textarea
          :counter="counter"
          :rules="incentive_rules"
          name="input-7-1"
          outlined
          dense
          v-model="sign_on_incentive"
        />
      </v-col>
    </v-row>
    <!-- <v-row id="product__rowpadding" v-if="communication_type === 1"> -->
    <!-- <v-row id="product__rowpadding">
            <v-col :cols="4" class="label-field text-left no-right no-bottom">Ongoing Incentive : </v-col>
            <v-col :cols="6" class="text-left no-left no-bottom no-top">
                <v-textarea name="input-7-1" outlined dense v-model="sign_on_incentive"/>
            </v-col>
        </v-row> -->
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Incentive Type #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-select
          :items="all_sign_on_incentive_type"
          dense
          v-model="sign_on_incentive_type"
          outlined
        />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Incentive Value #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="sign_on_incentive_value" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Accelerator Per #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="sign_on_acceleretor_per" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Accelerator Type #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-select
          :items="all_sign_on_accelerator_type"
          outlined
          dense
          v-model="sign_on_acceleretor_type"
        />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Max award #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="sign_on_max_award" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Incentive Maximum Spend #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="sign_on_incentive_max_spend" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Incentive Minimum Spend #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="sign_on_incentive_min_spend" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Incentive Window (months) #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-text-field outlined dense v-model="sign_on_incentive_window_month" />
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Limited to Specific Category #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-radio-group
          :mandatory="false"
          row
          v-model="sign_on_limit_specific_category"
        >
          <v-radio label="Yes" :value="1"></v-radio>
          <v-radio label="No" :value="0"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row id="product__rowpadding" v-if="con2()">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Sign-on Fixed date #{{ c }} :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        <v-radio-group :mandatory="false" row v-model="sign_on_fixed_date">
          <v-radio label="Yes" :value="1"></v-radio>
          <v-radio label="No" :value="0"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Incentive3",
  data: () => ({
    c: 3,
  }),
  props : ["counter","incentive_rules"],
  computed: {
    ...mapGetters({
      communication_type: "ProductData/getCommunicationType",
      all_sign_on_accelerator_type: "ProductData/getAllSignOnAcceleratorType",
      all_sign_on_incentive_type: "ProductData/getAllSignOnIncentiveData",
      all_sectors: "ProductData/getSubmittableSectors",
    }),
    sign_on_incentive: {
      get: function () {
        return this.$store.getters["ProductData/getSignOn3Incentive"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn3Incentive", o);
      },
    },
    sign_on_incentive_type: {
      get: function () {
        return parseInt(
          this.$store.getters["ProductData/getSignOn3IncentiveType"]
        );
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn3IncentiveType", o);
      },
    },
    sign_on_incentive_value: {
      get: function () {
        return this.$store.getters["ProductData/getSignOn3IncentiveValue"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn3IncentiveValue", o);
      },
    },
    sign_on_acceleretor_per: {
      get: function () {
        return this.$store.getters["ProductData/getSignOn3AcceleretorPer"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn3AcceleretorPer", o);
      },
    },
    sign_on_acceleretor_type: {
      get: function () {
        return parseInt(
          this.$store.getters["ProductData/getSignOn3AcceleretorType"]
        );
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn3AcceleretorType", o);
      },
    },
    sign_on_max_award: {
      get: function () {
        return this.$store.getters["ProductData/getSignOn3MaxAward"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn3MaxAward", o);
      },
    },
    sign_on_incentive_max_spend: {
      get: function () {
        return this.$store.getters["ProductData/getSignOn3IncentiveMaxSpend"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn3IncentiveMaxSpend", o);
      },
    },
    sign_on_incentive_min_spend: {
      get: function () {
        return this.$store.getters["ProductData/getSignOn3IncentiveMinSpend"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn3IncentiveMinSpend", o);
      },
    },
    sign_on_incentive_window_month: {
      get: function () {
        return this.$store.getters[
          "ProductData/getSignOn3IncentiveWindowMonth"
        ];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn3IncentiveWindowMonth", o);
      },
    },
    sign_on_limit_specific_category: {
      get: function () {
        if (
          this.$store.getters["ProductData/getSignOn3LimitSpecificCategory"] ==
          ""
        ) {
          this.$store.dispatch(
            "ProductData/setSignOn3LimitSpecificCategory",
            0
          );
        }
        return this.$store.getters[
          "ProductData/getSignOn3LimitSpecificCategory"
        ];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn3LimitSpecificCategory", o);
      },
    },
    sign_on_fixed_date: {
      get: function () {
        if (this.$store.getters["ProductData/getSignOn3FixedDate"] == "") {
          this.$store.dispatch("ProductData/setSignOn3FixedDate", 0);
        }
        return this.$store.getters["ProductData/getSignOn3FixedDate"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setSignOn3FixedDate", o);
      },
    },
  },
  methods: {
    con1: function () {
      return this.$productutils.condition1(this);
    },
    con2: function () {
      return this.$productutils.condition2(this);
    },
  },
};
</script>